export default __webpack_public_path__ + "images/591b154fb3971253d58cc97c1045b338.svg";